module.exports = "<div \n    *ngIf=\"isOpen\"\n>\n    <div\n        #wrapper\n        class=\"modal__wrapper\"\n        (click)=\"wrapperClicked($event)\"\n    >\n        <div class=\"modal__container\">\n            <div class=\"modal__x-container\">\n                <svg (click)=\"close()\" class=\"modal__x icon-times\">\n                    <use xlink:href=\"#icon-times\"></use>\n                </svg>\n            </div>\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/generics/modal/modal.component.html
// module id = ./src/app/generics/modal/modal.component.html
// module chunks = main